















































































































import Vue from 'vue'
import {
  Parameter,
  FindParameter,
  GetListOfStatusParameter,
  StatusParameter,
} from '@/api/cems'
import moment from 'moment'
export default Vue.extend({
  name: 'TabParameter',
  // props: {
  //   stackId: Number,
  // },
  data() {
    return {
      destroyed: false,
      stackUID: '',
      checked: true,
      stacks: [],
      parameters: [] as Parameter[],
      mapStatus: {} as { [id: number]: StatusParameter },
    }
  },
  computed: {
    isInstrument(): boolean {
      return this.$store.getters.isInstrument
    },
  },
  methods: {
    async findStatusParameter() {
      const statusList = await GetListOfStatusParameter()
      for (const status of statusList) {
        this.mapStatus[status.id] = status
      }
    },
    async findParameter() {
      this.parameters = await FindParameter(this.stackUID)
    },
    onRowClick(uid: string) {
      this.$router.push(`parameter/${uid}`)
    },

    gotoAddNewParameter() {
      this.$router.push('parameter/new-parameter')
    },

    async continuousUpdate() {
      if (this.destroyed) {
        return
      }
      await this.findParameter()
      setTimeout(() => {
        this.continuousUpdate()
      }, 3000)
    },

    formatTime(t: Date): string {
      return moment(t).format('DD MMM, HH:mm:ss')
    },

    copyLinkToClipboard() {
      /* Get the text field */
      // eslint-disable-next-line
      const copyText: any = document.getElementById('link-parameters')

      copyText.type = 'text'

      /* Select the text field */
      copyText.select()
      copyText.setSelectionRange(0, 99999) /* For mobile devices */

      /* Copy the text inside the text field */
      document.execCommand('copy')
      copyText.type = 'hidden'
    },
  },

  async created() {
    await this.findStatusParameter()
    this.stackUID = this.$route.params.stackUID
    this.continuousUpdate()
  },

  beforeDestroy() {
    this.destroyed = true
  },
})
